<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
     <article @click.self="open = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
                <img src="static/img/assets/nav_people_on.png" alt="">
                {{$t('groupListStr')}}
            </h1>
            <span class="info-right">
            </span>
        </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight">
        <!-- 1on1item -->
        <div class="ibox">
            <div class="ibox-content">
                <div class="ibox-title search-box">
                <div class="row">
                    <div class="col-sm-12">
                      <form @submit.prevent>
                        <div class="input-group">
                          <input v-model="searchText" type="text" class="typeahead_2 form-control" :placeholder="$t('searchWithGroupName')">
                        </div>
                      </form>
                    </div>
                </div>
                </div>
                <div class="ibox-content search-resultview">
                <ul v-if="searchText == ''">
                    <li id="group1" class="flex-box fl-between group-item cursor">
                      <h4 class="title-label" for="status">{{$t('groupListStr')}}</h4>
                      <span class="info-right">
                          <router-link class="btn btn-success add-public" to="group-regist">
                            <i class="fa fa-plus"></i>{{$t('groupRegTitle')}}
                          </router-link>
                      </span>
                    </li>
                      <li v-for="(group, groupId) in getCurrentActiveGroupsInfo" @click="onClickGroup(group, groupId)" :key="groupId"  class="flex-box fl-between group-item cursor">
                      <span v-if="group.ownerId == getUserId" class="crown-mark"><img :src="'static/img/assets/master.png'" alt=""></span>
                      <span class="group-name">{{ group.groupName }}</span>
                      <span class="group-info">{{$t('memberStr')}}:
                        <span class="menber-count">({{ Object.keys(group.members).length }})</span>
                        <span class="group-edit">
                          <group-drop-down v-if="group.ownerId == getUserId" :tag="tag" :item="group" :id="groupId"/>
                          <div v-if="group.ownerId != getUserId" class="collups-edit"></div>
                        </span>
                      </span>
                    </li>
                </ul>
                <ul v-else>
                  <li><label>{{$t('searchResuleStrType')}}</label></li>
                  <template v-if="Object.keys(this.getGroupsBySearchText).length === 0">
                    <li><label>{{$t('notFoundGroupNameStr')}}</label></li>
                  </template>
                  <template v-else>
                    <li v-for="(group, groupId) in getGroupsBySearchText" @click="onClickGroup(group, groupId)" v-if="group && group.groupName && group.members && group.ownerId" :key="groupId" class="flex-box fl-between group-item cursor">
                      <span class="group-name">{{ group.groupName }}</span>
                      <span class="group-info">{{$t('memberStr')}}:
                        <span class="menber-count">({{Object.keys(group.members).length}})</span>
                        <span class="group-edit">
                          <group-drop-down v-if="group.ownerId == getUserId" :tag="tag" :item="group" :id="groupId"/>
                          <div v-if="group.ownerId != getUserId" class="collups-edit"></div>
                        </span>
                      </span>
                      </li>
                  </template>
                </ul>
                </div>
                <!-- /公開設定 -->
            </div>
        </div>
        <!-- /1on1item -->
        </section>
      </article>

      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <div class="close-content"><div @click="open = false" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
        <article class="sub-content-wrap">
          <section class="inner-wrap">
            <div class="s-inner-wrap" v-if=open>
              <div class="ibox-title flex-box fl-between ibox-detail-header">
                <span class="info-menu flex-box">
                  {{ this.targetGroup.groupName }}
                </span>
                <span class="info-right">
                  <span class="group-info">{{$t('memberStr')}}: ({{Object.keys(this.targetGroup.members).length}})</span>
                </span>
              </div>
              <template>
                <div class="ibox-child">
                  <div class="search-resultview">
                    <ul>
                      <li v-for="user in getUsersInfo" :key="user.id"><label>
                        <router-link :to="{ name: 'User', params: { userId: user.userId }}">
                          <span class="search-userimg">
                            <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                            <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                          </span>
                        </router-link>
                        <div class="search-userinfo">
                          <span class="search-username">{{ user.userInfo.userName }}</span>
                          <span class="search-userdept">{{ user.userInfo.dept }}</span>
                        </div>
                      </label></li>
                    </ul>
                  </div>
                </div>
              </template>
            </div>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import GroupDropDown from '@/components/People/GroupDropDown'
import { mapGetters } from 'vuex'

export default {
  name: 'GroupList',
  components: {
    GroupDropDown
  },
  data: function () {
    return {
      tag: 'groupList',
      searchText: '',
      open: false,
      result: false,
      targetGroup: {
        members: {},
        groupName: ''
      },
      targetGroupId: ''
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'GroupList'
    },
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('groups/', [
      'getOnlyGroupsByText',
      'getOnlyGroupsByIds',
      'getCurrentActiveGroups',
      'getGroups'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds'
    ]),
    getGroupsBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getGroups
      } else {
        return this.getOnlyGroupsByText(this.searchText)
      }
    },
    getUsersInfo: function () {
      return this.getUsersByIds(Object.keys(this.targetGroup.members))
    },
    getCurrentActiveGroupsInfo: function () {
      let groups = this.getOnlyGroupsByIds(Object.keys(this.getCurrentActiveGroups))
      delete groups['.key']
      return groups
    }
  },

  mounted: function () {
    if (this.$route.params.item) {
      this.targetGroup = this.getCurrentActiveGroupsInfo[this.$route.params.item.group]
      this.targetGroupId = this.$route.params.item.group
      if (this.targetGroup) {
        this.open = true
      } else {
        const $t = this.$t
        this.$swal({
          title: $t('popTitleStrType'),
          text: $t('deletedGroupStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      }
    }
  },
  methods: {
    onClickGroup: function (group, id) {
      this.targetGroup = group
      this.targetGroupId = id
      if (!this.open) {
        this.open = true
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/people/GroupList.vue